import { render } from "./_Form.vue?vue&type=template&id=09d3f2d8"
import script from "./_Form.vue?vue&type=script&lang=js"
export * from "./_Form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__